import api from "./api";

const sampleTypeConfigService = {
  // Tube links
  getSampleTypeTubeTypes: (sampleTypeId) =>
    api.get(`/sample-types/${sampleTypeId}/tube-types`),
  setSampleTypeTubeTypes: (sampleTypeId, tubeTypeIds) =>
    api.put(`/sample-types/${sampleTypeId}/tube-types`, {
      tube_type_ids: tubeTypeIds,
    }),

  // Parameters
  getSampleTypeParameters: (sampleTypeId) =>
    api.get(`/sample-types/${sampleTypeId}/parameters`),
  createSampleTypeParameter: (sampleTypeId, data) =>
    api.post(`/sample-types/${sampleTypeId}/parameters`, data),
  updateSampleTypeParameter: (parameterId, data) =>
    api.put(`/sample-types/parameters/${parameterId}`, data),
  deleteSampleTypeParameter: (parameterId) =>
    api.delete(`/sample-types/parameters/${parameterId}`),

  // Ranges
  getTemplateRangesByParameter: (parameterId) =>
    api.get(`/sample-types/parameters/${parameterId}/ranges`),
  createTemplateRange: (parameterId, data) =>
    api.post(`/sample-types/parameters/${parameterId}/ranges`, data),
  updateTemplateRange: (rangeId, data) => api.put(`/sample-types/ranges/${rangeId}`, data),
  deleteTemplateRange: (rangeId) => api.delete(`/sample-types/ranges/${rangeId}`),
};

export default sampleTypeConfigService;
